<template>
    <div class="main-cn">
        <div class="main-bd mg20">
            <el-row class="searchSection" >

                <el-form ref="form" :inline="true" :model="searcherModel" class="demo-form-inline">
                    <el-form-item label="客户名称" prop="name">
                        <CustomerSelect ref="CustomerSelect" :customer-idss="searcherModel.name" v-model="searcherModel.name" @change="CustomerHandleChange"></CustomerSelect>
                    </el-form-item>
                    <el-form-item label="业务员" prop="user_id" >
                        <UserSelect ref="UserSelectSale" :name="searcherModel.sale_user_name" v-model="searcherModel.sale_user_id" @change="BusinessManHandleChange"></UserSelect>
                    </el-form-item>
                    <el-form-item label="跟进人" prop="user_id" >
                        <UserSelect ref="UserSelect" :name="searcherModel.username" v-model="searcherModel.user_id" @change="UserHandleChange"></UserSelect>
                    </el-form-item>
                    <el-form-item label="所属部门">
                        <UserCascader ref="UserCascader" v-model="searcherModel.branch_id" :isBusiness="true" @change="changeBranch"></UserCascader>
                    </el-form-item>
                    <el-form-item label="记录来源" prop="origin">
                        <el-select v-model="searcherModel.origin" size="small">
                            <el-option label="不限" value="0"></el-option>
                            <el-option label="客户" value="1"></el-option>
                            <el-option label="线索" value="2"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="客户级别" >
                        <el-select v-if="levels" size="small" v-model="searcherModel.level" placeholder="请选择" >
                            <el-option v-for="(item,key) in levels" :key="key" :label="item" :value="key" >
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="联系人姓名">
                        <contact-select ref="ContactSelect" v-model="searcherModel.contact_name" @change="ContactHandleChange" ></contact-select>
                    </el-form-item>
                    <el-form-item label="跟进时间">
                        <el-date-picker
                        size="small"
                        v-model="searcherModel.traceTimes"
                        type="daterange"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        >
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="跟进内容" prop="key_word">
                        <el-input size="small" v-model="searcherModel.key_word" placeholder="请输入关键词"></el-input>
                    </el-form-item>
                    <el-form-item label="屏蔽重复跟进" prop="is_distinct">
                        <el-select v-model="searcherModel.is_distinct" size="small">
                            <el-option label="不限" value="0"></el-option>
                            <el-option label="是" value="1"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" size="small" icon="el-icon-search" @click="submitSearch">搜索</el-button>
                        <el-button size="small" @click="resetForm()">重置</el-button>
                        <ExportFile 
                            v-if="Acs('/export/trance-log')"
                            url="/api/export/trance-log" 
                            :params="searcherModel" 
                            filename="跟进日志记录表" 
                            buttonName="导出Excel">
                        </ExportFile>
                    </el-form-item>
                </el-form>
            </el-row>
            <div style="float: right"><p style="color: red">未选择时间，默认只展示今年跟进记录</p></div>
            <el-table :data="customers" style="width: 100%" class="tabTopBorder" v-loading="loading"  v-watermask>
                <el-table-column prop="id" label="跟进ID"></el-table-column>
                <el-table-column prop="origin" label="来源"></el-table-column>
                <el-table-column label="客户名称" prop="customer_name" ></el-table-column>
                <el-table-column prop="customer_level" label="级别" ></el-table-column>
                <el-table-column prop="content" label="跟进内容" style="font-color: #1890ff">
                    <template slot-scope="scope">
                        <div v-html="scope.row.content"></div>
                    </template>
                </el-table-column>
                <el-table-column prop="created_at" label="跟进时间" ></el-table-column>
                <el-table-column prop="username" label="跟进人" ></el-table-column>
                <el-table-column prop="sale_name" label="业务员" ></el-table-column>
                <el-table-column prop="" label="操作" >
                    <template slot-scope="scope">
                        <el-button type="text" @click="handleView(scope.row)">查看</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-row v-if="linkPage">
                <pagination :linkPage="linkPage"></pagination>
            </el-row>
        </div>
    </div>
</template>

<script>
    import Pagination from "~/widgets/Pagination.vue";
    import CustomerService from "~/services/customer";
    import UserSelect from "~/widgets/UserSelect.vue";
    import CustomerSelect from "~/widgets/CustomerSelect.vue";
    import UserCascader from "~/widgets/UserCascader.vue";
    import Config from "~/config/params";
    import ContactSelect from "~/widgets/ContactSelect.vue";
    import ExportFile from "~/widgets/ExportFile.vue";
    export default {
        components: {
            UserSelect,
            CustomerSelect,
            Pagination,
            UserCascader,
            ContactSelect,
            ExportFile
        },
        data() {
            return {
                searcherModel: {},
                customers: [],
                loading: false,
                // 分页信息
                linkPage: null,
	            formLabelWidth: '120px',
                levels: {},
            };
        },

        // 监听路由参数更新执行分页请求
        beforeRouteUpdate: function (to, from, next) {
	        this.searcherModel['page'] = to.query["page"];
	        this.searcherModel['perPage'] = to.query["perPage"];
            this.submitSearch();
        },

        created: function () {
            this.levels = CustomerService.getLevels(true);
            this.resetForm();
        },

        //监听$route, 路由有变化时，重载列表。
        watch: {
            $route: function (value, oldValue) {
                this.resetForm();
            }
        },

        methods: {
            // 客户列表展示
            initListData(params = {}) {
                // loading 动画
                this.loading = true;
                let dtd;
                dtd = CustomerService.getTranceLog(params);
                dtd.then(res => {
                    this.customers =  res.data;
                    if (res._meta) {
                        this.linkPage = res._meta;
                    }
                    this.loading = false;
                })

            },

            // 筛选查询
            submitSearch() {
                this.initListData(this.searcherModel);
            },

            resetFields(){
                this.searcherModel = {
                    name: '',
                    user_id:'',
                    sale_user_name:'',
                    sale_user_id:'',
                    username:'',
                    key_word:'',
                    branch_id: '',
                    origin: '',
                    is_distinct: '',
                    level:'',
                    traceTimes: Config.getDataTimes('this_month'),
                    id:'',
                    contact_name: '',
                };
                if(this.$refs['CustomerSelect']){
                    this.$refs['CustomerSelect'].reset();
                }
                if(this.$refs['UserSelectSale']){
                    this.$refs['UserSelectSale'].reset();
                }
                if(this.$refs['UserSelect']){
                    this.$refs['UserSelect'].reset();
                }
                if(this.$refs['UserCascader']){
                    this.$refs["UserCascader"].reset();
                }
            },

            // 重置筛选表单
            resetForm() {
                this.resetFields();
                this.submitSearch()
            },

            //业务员姓名远程搜索组件赋值
	        UserHandleChange(obj) {
		        this.searcherModel.username = obj.value;
            },

            BusinessManHandleChange(obj){
                this.searcherModel.sale_user_name = obj.value;
            },

            //客户名称远程搜索组件赋值
            CustomerHandleChange(object) {
                this.searcherModel.name = object.value;
            },

            handleView(row) {
                let isClue = row.customer_id == 0 && row.sale_clue_id > 0;
                // 判断是线索还是客户跟进记录，跳转到对应的详情页
                if (isClue) {
                    this.toSaleClue(row.sale_clue_id);
                } else {
                    this.toCustomer(row.customer_id);
                }
            },

            toSaleClue(sale_clue_id) {
                let routeData = this.$router.resolve({
                    path: '/sales-leads/view?id=' + sale_clue_id
                });
                window.open(routeData.href, '_blank');
               // this.$router.push({path: '/sales-leads/view?id=' + sale_clue_id});
            },

            toCustomer(customer_id){
              /*  let path = "/customers/view?id="+ customer_id;
                this.$router.push({
                    path: path
                });*/
                let routeData = this.$router.resolve({
                    path:"/customers/view?id="+ customer_id
                });
                window.open(routeData.href, '_blank');
            },
            
            changeBranch(value) {
                if (value.length > 0) {
                    // 取得最后一级部门作为所属部门
                    this.searcherModel.branch_id = value[value.length - 1];
                } else {
                    this.searcherModel.branch_id = "";
                }
            },

            //联系人远程搜索组件赋值
            ContactHandleChange(object) {
                this.searcherModel.contact_name = object.value;
            },
        }
    };
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
    .customer-name {
        cursor: pointer;
    }

    .customer-name:hover {
        color: #409EFF;
    }
</style>


// WEBPACK FOOTER //
// src/views/customer/tranceLog.vue